import React, { useEffect, useState } from "react";
import { Context, InputTypes, Operators } from "../../../../policy-engine/constants";
import { getLeafs, getNestedValueWithGlob } from "../../../../policy-engine/utils/object";
import ToggleButton from "../../../../components/ToggleButton/ToggleButton";
import { LuPlus } from "react-icons/lu";
import { MdOutlineDelete } from "react-icons/md";
import InputDate from "../../../../components/InputDate/InputDate";

function Condition({ attribute, operator, value, ...props }) {

	const [attributeData, setAttributeData] = useState(null);

	useEffect(() => {
		const data = getNestedValueWithGlob(Context, attribute);
		setAttributeData(data);
	}, [attribute]);

	function onAttributeChange(value) {
		props.onUpdateField(value, 'attribute');
		props.onUpdateField(null, 'value');
		props.onUpdateField(null, 'operator');
	}

	useEffect(() => {
		if (['$in', '$nin'].includes(operator)) {
			if (!Array.isArray(value)) props.onUpdateField([value], 'value');
		} else if (Array.isArray(value)) {
			props.onUpdateField(value?.[0], 'value');
		}
	}, [operator, attribute]);

	function getAttributes() {
		const attributes = getLeafs(Context).map(attribute => ({
			key: attribute.path,
			value: attribute.data.description,
		}));
		return [
			{ key: 0, value: 'Selecione um atributo' },
			...attributes,
		]
	}

	function getOperators() {
		const operators = Operators.map(operator => ({
			key: operator.key,
			value: operator.description,
		})).filter(operator => attributeData?.allowedOperators && (attributeData.allowedOperators.includes(operator.key) || attributeData.allowedOperators === 'all'));
		return [
			{ key: 0, value: 'Selecione uma operação' },
			...operators,
		]
	}

	function getInput(value, onChange) {
		if (attributeData?.type === InputTypes.Boolean) {
			return (
				<ToggleButton
					style={{ width: 'fit-content' }}
					label={`${value ? "Sim" : "Não"}`}
					onChange={(e) => onChange(e.target.checked)}
					selected={value}
				/>
			);
		}
		const typeString = InputTypes.toString(attributeData?.type) ?? 'text';
		if (attributeData?.type === InputTypes.Date) {
			return (
				<InputDate type={typeString} name="value" placeholder="Valor" value={value ?? ''} onChange={e => {
					onChange(e.target.value)
				}} />
			);
		}
		return (
			<input type={typeString} name="value" placeholder="Valor" value={value ?? ''} onChange={e => {
				onChange(e.target.value)
			}} />
		)
	}

	function addValue() {
		if (Array.isArray(value)) {
			props.onUpdateField([...value, null], 'value');
		}
	}

	function removeValue(idx) {
		if (Array.isArray(value)) {
			props.onUpdateField([
				...value.slice(0, idx),
				...value.slice(idx + 1)
			], 'value');
		}
	}

	function getValueHandler() {
		if (Array.isArray(value)) {
			return (
				<div className="politica-container-values">
					{value.map((valueItem, idx) => (
						<React.Fragment key={idx}>
							<div className="wrapper-politica-input-value">
								{getInput(valueItem, (newValue) => {
									const newValues = [...value];
									newValues[idx] = newValue;
									props.onUpdateField(newValues, 'value');
								})}
								{idx > 0 && (
									<button type="button" className="btn-delete-condition-value" onClick={(e) => removeValue(idx)}><MdOutlineDelete size={18} /></button>
								)}
							</div>
						</React.Fragment>
					))}
					<button type="button" className="btn-add-condition-value" onClick={(e) => addValue()}><LuPlus size={18} /></button>
				</div>
			)
		}
		return getInput(value, (newValue) => {
			props.onUpdateField(newValue, 'value');
		});
	}

	return (
		<div className="condition-item">
			<select name="attribute" value={attribute ?? ''} onChange={e => onAttributeChange(e.target.value)}>
				{getAttributes().map((o, idx) => (
					<option key={idx} value={o.key}>{o.value}</option>
				))}
			</select>
			<select name="operator" value={operator ?? ''} onChange={e => props.onUpdateField(e.target.value, 'operator')}>
				{getOperators().map((o, idx) => (
					<option key={idx} value={o.key}>{o.value}</option>
				))}
			</select>
			<div className="container-condition-values">
				<div className="condition-values-controls">
					<p>Valor:</p>
				</div>
				{getValueHandler()}
			</div>
		</div>
	);
}

export default Condition;